import { defineWidgetCore } from "../../widgetDefinition";
import { resolveTemplate } from "../../Utils/resolveTemplate";
import type { GaugeComponentSpec, GaugeProcessedData, GaugeResponseData } from "../../Processing/types";
import { buildGaugeOptions } from "../../WidgetComponents/buildGaugeOptions";
import { renderGauge } from "../../PDF/renderers/gaugePdfRenderer";

export const gaugeCore = defineWidgetCore<GaugeComponentSpec>({
  process(spec, response) {
    const s = spec;
    const ns = response?.non_series_response;
    const gaugeData = ns?.type === "gauge" ? (ns as GaugeResponseData) : null;

    const needleValue = gaugeData?.needle_value ?? null;
    const maxValue = gaugeData?.max_value ?? 100;
    const minValue = gaugeData?.min_value ?? 0;
    const numDecimals = gaugeData?.num_decimals ?? null;

    const chartOptions = buildGaugeOptions(s, needleValue, minValue, maxValue, numDecimals);

    return {
      type: "gauge",
      spec: s,
      gauge: { chartOptions, needleValue, maxValue, minValue } as GaugeProcessedData,
    };
  },
  pdf: {
    capture: "highcharts",
    buildSnapshot({ processed, slicerValues }) {
      if (processed.type !== "gauge") return null;
      const rawTitle = processed.spec.display.title;
      return {
        type: "gauge",
        title: rawTitle == null ? null : resolveTemplate(rawTitle, slicerValues).resolved,
        summary: null,
      };
    },
    render({ id, snapshot, rect, scale, chartImages }) {
      if (snapshot.type !== "gauge") return null;
      return renderGauge(snapshot, rect, scale, chartImages[id]);
    },
  },
});
